import { appUrl } from "../../../constants/url-constants";

export const getDlsCompatibleList = (list = []) => {
    return (list || []).map((item) => {
        return {
            name: item.name,
            code: item.code,
            isHyperLink: true,
            url: `${appUrl()}/${item.url}/`
        };
    });
};
